// @flow
import type {SsoUserCloseResendActivationEmailModalAction, SsoUserOpenResendActivationEmailModalAction} from "../ssoUserResendActivationEmailAction";

/**
 * Created by Mike Chung on 2/13/18.
 */

export function openSsoUserResendActivationEmailModalAction(ssoUid: string): SsoUserOpenResendActivationEmailModalAction {
    return {
        type: "sso/SHOW_RESEND_EMAIL_MODAL_ACTION",
        ssoUid: "" + ssoUid
    }
}

export function closeSsoUserResendActivationEmailModalAction(): SsoUserCloseResendActivationEmailModalAction {
    return {
        type: "sso/HIDE_RESEND_EMAIL_MODAL_ACTION"
    }
}



// WEBPACK FOOTER //
// ./src/actions/modal/creators/ssoUserResendActivationEmailActionCreator.js